// extracted by mini-css-extract-plugin
export default {"container":"RemediesGuide_container__Z+c+P","searchMenu":"RemediesGuide_searchMenu__utfjg"};